import * as NavConstants from 'constants/NavConstants';
import {getStore} from 'redux-stores/Store';
import {maybeRefreshListing} from 'search/SearchUIReduxActions';

export function refreshListingsWithAnalysesAndAnalyticsDashboards(): void {
  // This may be called before the listings are opened, in which case they should no-op
  getStore().dispatch(maybeRefreshListing(NavConstants.SECTIONS.ANALYTICS));
  getStore().dispatch(maybeRefreshListing(NavConstants.SECTIONS.SEARCH));
}
